// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const EyeInActive: React.FC = () => {
    return <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 11.9 13.8" color="currentColor" fill="currentColor">
	  <path d="M9.7,10.7L2.1,3.1h0c-.2-.2-.5-.2-.6,0-.2.2-.2.5,0,.6l.7.7c-.8.6-1.5,1.3-2,2.1-.2.3-.2.6,0,.9,1.4,2.1,3.6,3.3,5.8,3.2.7,0,1.4-.1,2.1-.4l1.1,1.1c.2.2.5.2.6,0,.2-.2.2-.4,0-.6h0ZM5.9,9.4c-1.4,0-2.5-1.1-2.5-2.5,0-.4,0-.7.2-1l.7.7c-.2.9.4,1.7,1.2,1.9.2,0,.4,0,.7,0l.7.7c-.3.1-.7.2-1,.2ZM11.7,6.5c-1.4-2.1-3.6-3.3-5.8-3.2-.7,0-1.4.1-2.1.4l1.1,1.1c1.3-.6,2.7,0,3.3,1.2.3.7.3,1.4,0,2.1l1.5,1.5c.8-.6,1.5-1.3,2-2.1.2-.3.2-.6,0-.9Z"/>
	  <path d="M5.9,5.3c-.1,0-.2,0-.3,0l1.9,1.9c.2-.9-.4-1.7-1.2-1.9-.1,0-.2,0-.3,0Z"/>
	</svg>;
};

export default React.memo(EyeInActive);
